import React from 'react'
import calendar from '../../../assets/images/calendar-icon.png'
import remind from '../../../assets/images/remind.png'
import useClickOutside from '../../../useClickOutside';

const Addevent = ({ setChoiceEvent,setaddEvent, setcreateEvent }) => {
    let domNode = useClickOutside(() => {
        setaddEvent(false);
    });
    return (
        <div className='add-event' ref={domNode} >
            <div className='one-event' onClick={() => {setcreateEvent(true);setChoiceEvent('event')}} >
                <img style={{ width: "13px", height: "13px" }} src={calendar} />
                <span>Add Event</span>
            </div>
            <div className='one-event'onClick={() => {setcreateEvent(true);setChoiceEvent('reminder')}} >
                <img style={{ width: "13px", height: "13px" }} src={remind} />
                <span>Add Reminder</span>
            </div>
        </div>
    )
}

export default Addevent